var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1528_46494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9823 13.8592C21.3354 11.0861 23.6317 8.88539 26.4598 7.65137L26.6329 7.57585C31.5657 5.42346 37.0184 4.75339 42.3256 5.6474V5.6474C42.4344 5.66573 42.5197 5.75101 42.538 5.85986V5.85986C43.432 11.167 42.762 16.6197 40.6096 21.5525L40.534 21.7256C39.3 24.5537 37.0993 26.85 34.3262 28.2031L23.266 33.6C22.5391 33.9546 21.6672 33.8088 21.0953 33.2369L14.9485 27.0901C14.3766 26.5182 14.2308 25.6463 14.5855 24.9194L19.9823 13.8592Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5305,
    cy: 16.649,
    r: 4,
    transform: "rotate(45 31.5305 16.649)",
    fill: "none",
    stroke: "current",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3369 11.1563L14.6937 11.6459L8.94366 21.6052L16.2699 20.9325",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.048 26.8627L36.5583 33.5059L26.599 39.2559L27.2717 31.9297",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5183 32.4727C13.944 32.4727 15.9104 34.4391 15.9104 36.8648V36.8648C15.9104 38.7968 14.6479 40.502 12.7999 41.0658L6.70668 42.9247C5.94092 43.1583 5.22478 42.4421 5.4584 41.6764L7.31728 35.5832C7.88105 33.7352 9.58621 32.4727 11.5183 32.4727V32.4727Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1528_46494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReady);
export default __webpack_public_path__ + "static/media/ready.91db483c82162d227680e8bde14464f4.svg";
export { ForwardRef as ReactComponent };